<template>
  <i :class="props.hover ? 'hover' : ''"
     :data-type="props.type"
     class="vue-feather vue-feather--plus iconsax">
    <Activity v-if="props.type==='activity'" />
    <Add v-else-if="props.type==='add'" />
    <Alarm v-else-if="props.type==='alarm'" />
    <ArrowLeftRight v-else-if="props.type==='arrow-left-right'" />
    <ArrowLeft v-else-if="props.type==='arrow-left'" />
    <ArrowRight v-else-if="props.type==='arrow-right'" />
    <ArrowRight1 v-else-if="props.type==='arrow-right-1'" />
    <ArrowSort v-else-if="props.type==='arrow-sort'" />
    <ArrowUpDown v-else-if="props.type==='arrow-up-down'" />
    <ArrowUp v-else-if="props.type==='arrow-up'" />
    <ArrowUpLine v-else-if="props.type==='arrow-up-line'" />
    <ArrowDown v-else-if="props.type==='arrow-down'" />
    <Audio v-else-if="props.type==='audio'" />
    <Bell v-else-if="props.type==='bell'" />
    <Bezier v-else-if="props.type==='bezier'" />
    <Blur v-else-if="props.type==='blur'" />
    <Book v-else-if="props.type==='book'" />
    <Box v-else-if="props.type==='box'" />
    <Briefcase v-else-if="props.type==='briefcase'" />
    <Broom v-else-if="props.type==='broom'" />
    <Calendar v-else-if="props.type==='calendar'" />
    <CallCalling v-else-if="props.type==='call-calling'" />
    <CardPos v-else-if="props.type==='card-pos'" />
    <Category v-else-if="props.type==='category'" />
    <Check v-else-if="props.type==='check'" />
    <Circle v-else-if="props.type==='circle'" />
    <Clock v-else-if="props.type==='clock'" />
    <Coffee v-else-if="props.type==='coffee'" />
    <Command v-else-if="props.type==='command'" />
    <Copy v-else-if="props.type==='copy'" />
    <Cup v-else-if="props.type==='cup'" />
    <Clipboard v-else-if="props.type==='clipboard'" />
    <Danger v-else-if="props.type==='danger'" />
    <Diagram v-else-if="props.type==='diagram'" />
    <Disable v-else-if="props.type==='disable'" />
    <DiscountCircle v-else-if="props.type==='discount-circle'" />
    <DollarCircle v-else-if="props.type==='dollar-circle'" />
    <Download v-else-if="props.type==='download'" />
    <Driver2 v-else-if="props.type==='driver-2'" />
    <Edit v-else-if="props.type==='edit'" />
    <EyeOff v-else-if="props.type==='eye-off'" />
    <Eye v-else-if="props.type==='eye'" />
    <Fatrows v-else-if="props.type==='fatrows'" />
    <Flash v-else-if="props.type==='flash'" />
    <Flag2 v-else-if="props.type==='flag-2'" />
    <FingerScan v-else-if="props.type==='finger-scan'" />
    <Enable v-else-if="props.type==='enable'" />
    <FolderAdd v-else-if="props.type==='folder-add'" />
    <FolderMinus v-else-if="props.type==='folder-minus'" />
    <Folder v-else-if="props.type==='folder'" />
    <FormatSquare v-else-if="props.type==='format-square'" />
    <Forward v-else-if="props.type==='forward'" />
    <Gallery v-else-if="props.type==='gallery'" />
    <Glass v-else-if="props.type==='glass'" />
    <Global v-else-if="props.type==='global'" />
    <Home v-else-if="props.type==='home'" />
    <HashTag v-else-if="props.type==='hashtag'" />
    <Heart v-else-if="props.type==='heart'" />
    <HierarchySquare v-else-if="props.type==='hierarchy-square'" />
    <Hierarchy v-else-if="props.type==='hierarchy'" />
    <Instagram v-else-if="props.type==='instagram'" />
    <Issue v-else-if="props.type==='issue'" />
    <Judge v-else-if="props.type==='judge'" />
    <Js v-else-if="props.type==='js'" />
    <Key v-else-if="props.type==='key'" />
    <Lamp v-else-if="props.type==='lamp'" />
    <Link v-else-if="props.type==='link'" />
    <Location v-else-if="props.type==='location'" />
    <Login v-else-if="props.type==='login'" />
    <Logout v-else-if="props.type==='logout'" />
    <Maximize v-else-if="props.type==='maximize'" />
    <MaximizeOuter v-else-if="props.type==='maximize-outer'" />
    <Menu v-else-if="props.type==='menu'" />
    <Message v-else-if="props.type==='message'" />
    <Minus v-else-if="props.type==='minus'" />
    <Mirroring v-else-if="props.type==='mirroring'" />
    <Monitor v-else-if="props.type==='monitor'" />
    <Moon v-else-if="props.type==='moon'" />
    <More v-else-if="props.type==='more'" />
    <MouseSquare v-else-if="props.type==='mouse-square'" />
    <Move v-else-if="props.type==='move'" />
    <Music v-else-if="props.type==='music'" />
    <Next v-else-if="props.type==='next'" />
    <Next2 v-else-if="props.type==='next2'" />
    <Notification v-else-if="props.type==='notification'" />
    <Notification1 v-else-if="props.type==='notification-1'" />
    <Paperclip v-else-if="props.type==='paperclip'" />
    <People v-else-if="props.type==='people'" />
    <PasswordCheck v-else-if="props.type==='password-check'" />
    <PictureFrame v-else-if="props.type==='picture-frame'" />
    <Prev v-else-if="props.type==='prev'" />
    <Prev2 v-else-if="props.type==='prev2'" />
    <Profile v-else-if="props.type==='profile'" />
    <Profile2user v-else-if="props.type==='profile-2user'" />
    <ProfileAdd v-else-if="props.type==='profile-add'" />
    <ProfileRemove v-else-if="props.type==='profile-remove'" />
    <Project v-else-if="props.type==='project'" />
    <Property v-else-if="props.type==='property'" />
    <Radar v-else-if="props.type==='radar'" />
    <Refresh v-else-if="props.type==='refresh'" />
    <Refresh2 v-else-if="props.type==='refresh2'" />
    <ReceiptSquare v-else-if="props.type==='receipt-square'" />
    <Reset v-else-if="props.type==='reset'" />
    <RotateLeft v-else-if="props.type==='rotate-left'" />
    <RotateRight v-else-if="props.type==='rotate-right'" />
    <Save2 v-else-if="props.type==='save-2'" />
    <Scan v-else-if="props.type==='scan'" />
    <Scanner v-else-if="props.type==='scanner'" />
    <Send v-else-if="props.type==='send'" />
    <Search v-else-if="props.type==='search'" />
    <SecuritySafe v-else-if="props.type==='security-safe'" />
    <Setting v-else-if="props.type==='setting'" />
    <Setting4 v-else-if="props.type==='setting-4'" />
    <Share v-else-if="props.type==='share'" />
    <ShieldSlash v-else-if="props.type==='shield-slash'" />
    <ShieldTick v-else-if="props.type==='shield-tick'" />
    <SidebarLeft v-else-if="props.type==='sidebar-left'" />
    <SidebarRight v-else-if="props.type==='sidebar-right'" />
    <SmsSend v-else-if="props.type==='sms-send'" />
    <Smallcaps v-else-if="props.type==='smallcaps'" />
    <Solana v-else-if="props.type==='solana'" />
    <Star v-else-if="props.type==='star'" />
    <Sound v-else-if="props.type==='sound'" />
    <Sun v-else-if="props.type==='sun'" />
    <Tag v-else-if="props.type==='tag'" />
    <Text v-else-if="props.type==='text'" />
    <TimerStart v-else-if="props.type==='timer-start'" />
    <ToggleOffCircle v-else-if="props.type==='toggle-off-circle'" />
    <ToggleOnCircle v-else-if="props.type==='toggle-on-circle'" />
    <Transfer v-else-if="props.type==='transfer'" />
    <Trash v-else-if="props.type==='trash'" />
    <TruckRunning v-else-if="props.type==='truck-running'" />
    <Undo v-else-if="props.type==='undo'" />
    <Unlimited v-else-if="props.type==='unlimited'" />
    <User v-else-if="props.type==='user'" />
    <UserSquare v-else-if="props.type==='user-square'" />
    <UserSearch v-else-if="props.type==='user-search'" />
    <Video v-else-if="props.type==='video'" />
    <Waiting v-else-if="props.type==='waiting'" />
    <Wifi v-else-if="props.type==='wifi'" />
    <X v-else-if="props.type==='x'" />
    <Youtube v-else-if="props.type==='youtube'" />
    <ZoomIn v-else-if="props.type==='zoom-in'" />
    <ZoomOut v-else-if="props.type==='zoom-out'" />
    <Repeat v-else-if="props.type==='repeat'" />
    <Default v-else />
  </i>

</template>

<script setup>

import Activity from '@/asset/iconsax/activity.svg'
import Add from '@/asset/iconsax/add.svg'
import Alarm from '@/asset/iconsax/alarm.svg'
import ArrowLeftRight from '@/asset/iconsax/arrow-left-right.svg'
import ArrowLeft from '@/asset/iconsax/arrow-left.svg'
import ArrowRight1 from '@/asset/iconsax/arrow-right-1.svg'
import ArrowRight from '@/asset/iconsax/arrow-right.svg'
import ArrowSort from '@/asset/iconsax/arrow-sort.svg'
import ArrowUpDown from '@/asset/iconsax/arrow-up-down.svg'
import ArrowUp from '@/asset/iconsax/arrow-up.svg'
import ArrowUpLine from '@/asset/iconsax/arrow-up-line.svg'
import ArrowDown from '@/asset/iconsax/arrow-down.svg'
import Audio from '@/asset/iconsax/audio.svg'
import Bell from '@/asset/iconsax/bell.svg'
import Bezier from '@/asset/iconsax/bezier.svg'
import Blur from '@/asset/iconsax/blur.svg'
import Book from '@/asset/iconsax/book.svg'
import Box from '@/asset/iconsax/box.svg'
import Briefcase from '@/asset/iconsax/briefcase.svg'
import Broom from '@/asset/iconsax/broom.svg'
import Calendar from '@/asset/iconsax/calendar.svg'
import CallCalling from '@/asset/iconsax/call-calling.svg'
import CardPos from '@/asset/iconsax/card-pos.svg'
import Category from '@/asset/iconsax/category.svg'
import Check from '@/asset/iconsax/check.svg'
import Circle from '@/asset/iconsax/circle.svg'
import Clock from '@/asset/iconsax/clock.svg'
import Coffee from '@/asset/iconsax/coffee.svg'
import Command from '@/asset/iconsax/command.svg'
import Copy from '@/asset/iconsax/copy.svg'
import Cup from '@/asset/iconsax/cup.svg'
import Clipboard from '@/asset/iconsax/clipboard.svg'
import Default from '@/asset/iconsax/default.svg'
import Disable from '@/asset/iconsax/disable.svg'
import Diagram from '@/asset/iconsax/diagram.svg'
import Danger from '@/asset/iconsax/danger.svg'
import DiscountCircle from '@/asset/iconsax/discount-circle.svg'
import DollarCircle from '@/asset/iconsax/dollar-circle.svg'
import Download from '@/asset/iconsax/download.svg'
import Driver2 from '@/asset/iconsax/driver-2.svg'
import Edit from '@/asset/iconsax/edit.svg'
import Eye from '@/asset/iconsax/eye.svg'
import EyeOff from '@/asset/iconsax/eye-off.svg'
import Fatrows from '@/asset/iconsax/fatrows.svg'
import Flash from '@/asset/iconsax/flash.svg'
import Flag2 from '@/asset/iconsax/flag-2.svg'
import FingerScan from '@/asset/iconsax/finger-scan.svg'
import Enable from '@/asset/iconsax/enable.svg'
import FolderAdd from '@/asset/iconsax/folder-add.svg'
import FolderMinus from '@/asset/iconsax/folder-minus.svg'
import Folder from '@/asset/iconsax/folder.svg'
import FormatSquare from '@/asset/iconsax/format-square.svg'
import Forward from '@/asset/iconsax/forward.svg'
import Gallery from '@/asset/iconsax/gallery.svg'
import Glass from '@/asset/iconsax/glass.svg'
import Global from '@/asset/iconsax/global.svg'
import HashTag from '@/asset/iconsax/hashtag.svg'
import Home from '@/asset/iconsax/home.svg'
import Heart from '@/asset/iconsax/heart.svg'
import HierarchySquare from '@/asset/iconsax/hierarchy-square.svg'
import Hierarchy from '@/asset/iconsax/hierarchy.svg'
import Instagram from '@/asset/iconsax/instagram.svg'
import Issue from '@/asset/iconsax/issue.svg'
import Judge from '@/asset/iconsax/judge.svg'
import Js from '@/asset/iconsax/js.svg'
import Key from '@/asset/iconsax/key.svg'
import Lamp from '@/asset/iconsax/lamp.svg'
import Link from '@/asset/iconsax/link.svg'
import Location from '@/asset/iconsax/location.svg'
import Login from '@/asset/iconsax/login.svg'
import Logout from '@/asset/iconsax/logout.svg'
import Maximize from '@/asset/iconsax/maximize.svg'
import MaximizeOuter from '@/asset/iconsax/maximize-outer.svg'
import Menu from '@/asset/iconsax/menu.svg'
import Message from '@/asset/iconsax/message.svg'
import Minus from '@/asset/iconsax/minus.svg'
import Mirroring from '@/asset/iconsax/mirroring.svg'
import Monitor from '@/asset/iconsax/monitor.svg'
import More from '@/asset/iconsax/more.svg'
import MouseSquare from '@/asset/iconsax/mouse-square.svg'
import Move from '@/asset/iconsax/move.svg'
import Music from '@/asset/iconsax/music.svg'
import Next from '@/asset/iconsax/next.svg'
import Next2 from '@/asset/iconsax/next2.svg'
import Notification from '@/asset/iconsax/notification.svg'
import Notification1 from '@/asset/iconsax/notification-1.svg'
import Paperclip from '@/asset/iconsax/paperclip.svg'
import People from '@/asset/iconsax/people.svg'
import PasswordCheck from '@/asset/iconsax/password-check.svg'
import PictureFrame from '@/asset/iconsax/picture-frame.svg'
import Prev from '@/asset/iconsax/prev.svg'
import Prev2 from '@/asset/iconsax/prev2.svg'
import Moon from '@/asset/iconsax/moon.svg'
import Profile from '@/asset/iconsax/profile.svg'
import Profile2user from '@/asset/iconsax/profile-2user.svg'
import ProfileAdd from '@/asset/iconsax/profile-add.svg'
import ProfileRemove from '@/asset/iconsax/profile-remove.svg'
import Project from '@/asset/iconsax/project.svg'
import Property from '@/asset/iconsax/property.svg'
import Radar from '@/asset/iconsax/radar.svg'
import ReceiptSquare from '@/asset/iconsax/receipt-square.svg'
import Refresh from '@/asset/iconsax/refresh.svg'
import Refresh2 from '@/asset/iconsax/refresh-2.svg'
import Reset from '@/asset/iconsax/reset.svg'
import RotateLeft from '@/asset/iconsax/rotate-left.svg'
import RotateRight from '@/asset/iconsax/rotate-right.svg'
import Save2 from '@/asset/iconsax/save-2.svg'
import Scan from '@/asset/iconsax/scan.svg'
import Scanner from '@/asset/iconsax/scanner.svg'
import Search from '@/asset/iconsax/search.svg'
import SecuritySafe from '@/asset/iconsax/security-safe.svg'
import Send from '@/asset/iconsax/send.svg'
import Setting from '@/asset/iconsax/setting.svg'
import Setting4 from '@/asset/iconsax/setting-4.svg'
import Share from '@/asset/iconsax/share.svg'
import ShieldSlash from '@/asset/iconsax/shield-slash.svg'
import ShieldTick from '@/asset/iconsax/shield-tick.svg'
import SidebarLeft from '@/asset/iconsax/sidebar-left.svg'
import SidebarRight from '@/asset/iconsax/sidebar-right.svg'
import SmsSend from '@/asset/iconsax/sms-send.svg'
import Smallcaps from '@/asset/iconsax/smallcaps.svg'
import Solana from '@/asset/iconsax/solana.svg'
import Sound from '@/asset/iconsax/sound.svg'
import Star from '@/asset/iconsax/star.svg'
import Sun from '@/asset/iconsax/sun.svg'
import Tag from '@/asset/iconsax/tag.svg'
import ToggleOffCircle from '@/asset/iconsax/toggle-off-circle.svg'
import ToggleOnCircle from '@/asset/iconsax/toggle-on-circle.svg'
import TimerStart from '@/asset/iconsax/timer-start.svg'
import Text from '@/asset/iconsax/text.svg'
import Transfer from '@/asset/iconsax/transfer.svg'
import Trash from '@/asset/iconsax/trash.svg'
import TruckRunning from '@/asset/iconsax/truck-running.svg'
import Undo from '@/asset/iconsax/undo.svg'
import Unlimited from '@/asset/iconsax/unlimited.svg'
import User from '@/asset/iconsax/user.svg'
import UserSquare from '@/asset/iconsax/user-square.svg'
import UserSearch from '@/asset/iconsax/user-search.svg'
import Video from '@/asset/iconsax/video.svg'
import Waiting from '@/asset/iconsax/waiting.svg'
import Wifi from '@/asset/iconsax/wifi.svg'
import X from '@/asset/iconsax/x.svg'
import Youtube from '@/asset/iconsax/youtube.svg'
import ZoomIn from '@/asset/iconsax/zoom-in.svg'
import ZoomOut from '@/asset/iconsax/zoom-out.svg'
import Repeat from '@/asset/iconsax/repeat.svg'

const props = defineProps({
    type: { type: String, required: true },
    hover: { type: Boolean, required: false, default: true }
  })

</script>

<style scoped lang="scss">
@import "@/style/variables.scss";
i {
  &.active {
    color: map-get($theme-color, "primary") !important;
  }
  &.hover {
    &:hover {
      color: map-get($theme-color, "primary") !important;

    }
  }
}
.iconsax {
  display: flex;
  > svg {
    position: relative;
    top: -0.5px;
  }
  &.ft-10 {
    transform: scale(.42, .42);
    > svg {
      transform: scale(.42, .42);
    }
  }
  &.ft-12 {
    transform: scale(.5, .5);
    > svg {
      transform: scale(.5, .5);
    }
  }
  &.ft-14 {
    transform: scale(.6, .6);
    > svg {
      transform: scale(.6, .6);
    }
  }
  &.ft-16 {
    transform: scale(.68, .68);
    > svg {
      transform: scale(.68, .68);
    }
  }
  &.ft-18 {
    transform: scale(.75, .75);
    > svg {
      transform: scale(.75, .75);
    }
  }
  &.ft-20 {
    transform: scale(.85, .85);
    > svg {
      transform: scale(.85, .85);
    }
  }
  &.ft-22 {
    transform: scale(.92, .92);
    > svg {
      transform: scale(.92, .92);
    }
  }
  &.ft-24 {
    transform: scale(1, 1);
    > svg {
      transform: scale(1, 1);
    }
  }
  &.ft-26 {
    transform: scale(1.075, 1.075);
    > svg {
      transform: scale(1.075, 1.075);
    }
  }
  &.ft-28 {
    transform: scale(1.12, 1.12);
    > svg {
      transform: scale(1.12, 1.12);
    }
  }
  &.ft-32 {
    transform: scale(1.25, 1.25);
    > svg {
      transform: scale(1.25, 1.25);
    }
  }
  &.ft-36 {
    transform: scale(1.5, 1.5);
    > svg {
      transform: scale(1.5, 1.5);
    }
  }
  &.ft-article-kind,
  &.ft-notification-type {
    transform: scale(1.3, 1.3);
    > svg {
      transform: scale(1.3, 1.3);

    }
  }
}
</style>
